import React, { FC, memo } from "react";

import veramaLogo from "./assets/logo-verama.svg";
import veramaVmsLogotype from "./assets/logotype-verama-vms.svg";
import veramaLogotype from "./assets/logotype-verama.svg";
import { ILogoProps, Logo } from "./Logo";

export type IVeramaLogoVariant = "logotype" | "logo" | "vms";

const logoVariants: Record<IVeramaLogoVariant, string> = {
  logotype: veramaLogotype,
  logo: veramaLogo,
  vms: veramaVmsLogotype,
};

export interface IVeramaLogoProps extends Omit<ILogoProps, "src"> {
  src?: ILogoProps["src"] | null;
  variant?: IVeramaLogoVariant;
}

export const VeramaLogo: FC<IVeramaLogoProps> = memo(({ variant = "logotype", src, ...props }) => {
  const logoUrl = src ? src : logoVariants[variant];

  return <Logo src={logoUrl} {...props} />;
});
